import React from 'react';
import CloseIcon from '../../../icons/CloseIcon';
import { styled } from '@mui/material/styles';

const Container = styled('div')({
  minHeight: '56px',
  background: '#F4F4F6',
  borderBottom: '1px solid #E4E7E9',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 1em',
});

const Text = styled('div')({
  fontWeight: 'bold',
});

const CloseButton = styled('button')({
  cursor: 'pointer',
  display: 'flex',
  background: 'transparent',
  border: '0',
  padding: '0.4em',
});

interface BackgroundSelectionHeaderProps {
  onClose: () => void;
}

export default function BackgroundSelectionHeader({ onClose }: BackgroundSelectionHeaderProps) {
  return (
    <Container>
      <Text>Backgrounds</Text>
      <CloseButton onClick={onClose}>
        <CloseIcon />
      </CloseButton>
    </Container>
  );
}
